export const USER_FILTER_LEGAJO = 'legajo';
export const USER_FILTER_APELLIDO = 'apellido';
export const USER_FILTER_NOMBRE = 'nombre';
export const USER_FILTER_NIVEL = 'nivel';
export const USER_FILTER_PERFIL = 'perfil';
export const USER_FILTER_UNIDAD = 'unidad';
export const USER_FILTER_OFIJU = 'ofiju';